import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <>
      <div className="flex items-center gap-3" data-id="element-340">
        <div className="w-12 h-12 rounded-full bg-[#00C853]/20 border border-[#00C853]/40 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-341">
          {initials}
        </div>
        <div data-id="element-342">
          <div className="text-[#00C853] text-sm" data-id="element-343">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-344">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-345">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-346">
        &quot;{quote}&quot;
      </p>
    </>;
}
export function TestimonialsSection() {
  return <>
      <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-347">
        <div className="max-w-5xl mx-auto" data-id="element-348">
          <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-349">
            ❤️ MÁS DOCENTES QUE YA LO TIENEN
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10" data-id="element-350">
            <TestimonialCard initials="CR" stars={5} quote="El Contenuto Specchio me salvó. Ya no preparo dos versiones de cada clase. Mis estudiantes con dislexia por fin participan." name="C.R." location="MegaPack + Adaptaciones" level="" data-id="element-351" />
            <TestimonialCard initials="RM" stars={5} quote="Con el roleplay del café, en 10 minutos todo el grupo estaba hablando italiano sin vergüenza." name="R.M." location="Docente de Italiano" level="" data-id="element-352" />
            <TestimonialCard initials="SC" stars={5} quote="Mis estudiantes de A1 terminaron el nivel hablando italiano. Eso no pasaba nunca antes." name="S.C." location="Docente de Italiano" level="" data-id="element-353" />
            <TestimonialCard initials="PA" stars={5} quote="El framework de 20 segundos para corregir cambió todo. El ritmo de la clase ya no se interrumpe." name="P.A." location="Docente de Italiano" level="" data-id="element-354" />
          </div>
        </div>
      </section>
    </>;
}